import React from "react";

const Guides: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold text-gray-800 dark:text-white mb-6">
        Guides
      </h1>

      <div className="space-y-6">
        <div className="bg-white dark:bg-gray-800 rounded-lg p-6 shadow-md">
          <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-3">
            Getting Started
          </h2>
          <p className="text-gray-600 dark:text-gray-300">
            Welcome to devagile.tools! This site provides various tools for
            agile teams, developers, and team building activities.
          </p>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-lg p-6 shadow-md">
          <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-3">
            Team Tools
          </h2>
          <p className="text-gray-600 dark:text-gray-300">
            Use the team member management feature to keep track of your team.
            Set a team name and add/remove members easily.
          </p>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-lg p-6 shadow-md">
          <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-3">
            Random Tools
          </h2>
          <p className="text-gray-600 dark:text-gray-300">
            Explore our random tools for ice breakers, roulette games, and team
            name generation.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Guides;
